import { Network } from '../../../../utils/network'
import { Events } from '../../../../utils/servicesEvents'

import urls from '../urls.json'

async function saveStorePreferences(data, onSuccessEvent, onErrorEvent) {
  const response = await sendRequest(data)
  const parsedResponse = parseResponse(response, data)
  const onDoneEvent =
    parsedResponse.statusCode == 200 ? onSuccessEvent : onErrorEvent
  Events.dispatchEvent(onDoneEvent, parsedResponse)
}

async function sendRequest(data) {
  const url = urls.saveStorePreferences
  console.log(data)

  const response = await Network.sendPostRequest(url, data)
  return response
}

function parseResponse(response) {
  if (
    response &&
    response.status.code === 200 &&
    response.response.statusCode == 200
  ) {
    return {
      statusCode: 200,
    }
  }
  if (response.status.code === 0) {
    return {
      success: false,
      message: 'error',
      networkError: true,
    }
  }
  return {
    success: false,
    message: 'error',
  }
}

export { saveStorePreferences }
